import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import * as trackingActions from "./tracking.actions";
import { LocationTrackingDto } from "../interfaces/location_tracking";

export const trackingFeatureKey = "trackings";

export interface State {
    [trackingFeatureKey]: TrackingsState;
    isLoaded: boolean;
    isTracking: boolean;
    currentAppointmentId: number | null;
}

export interface TrackingsState extends EntityAdapter<LocationTrackingDto> {
    isLoaded: boolean;
    isTracking: boolean;
    currentAppointmentId: number | null;
}

export const adapter = createEntityAdapter<LocationTrackingDto>({
    selectId: (tracking: LocationTrackingDto) => String(tracking?.location_tracking_id) || "",
    sortComparer: false,
});

export const initialState = adapter.getInitialState({
    isTracking: false,
    isLoaded: true,
    currentAppointmentId: null,
});

const trackingsReducer = createReducer(
    initialState,
    on(trackingActions.getTrackingsSuccess, (state, {trackings}) => adapter.setAll(trackings, {...state, isLoaded: true})),
    on(trackingActions.upsertTrackingSuccess, (state, {tracking}) => adapter.upsertOne(tracking, {...state, isLoaded: true})),
    on(trackingActions.getTrackingsByAppointmentId, (state) => ({...state, isLoaded: false})),
    on(trackingActions.getTrackingsByAppointmentIdSuccess, (state, {trackings}) => adapter.upsertMany(trackings, {...state, isLoaded: true})),
    on(trackingActions.replaceTrackings, (state, {oldTrackings, newTrackings}) => adapter.removeMany(oldTrackings.map(tracking => tracking.location_tracking_id), {...state, isLoaded: false})),
    on(trackingActions.replaceTrackingsSuccess, (state, {trackings}) => adapter.upsertMany(trackings, {...state, isLoaded: true})),
    on(trackingActions.deleteTrackingSuccess, (state, {tracking}) => adapter.removeOne(String(tracking.location_tracking_id), {...state, isLoaded: true})),
    on(trackingActions.startTracking, (state, {appointmentId}) => ({...state, isTracking: true, currentAppointmentId: appointmentId})),
    on(trackingActions.stopTracking, (state) => ({...state, isTracking: false, currentAppointmentId: null})),
);

export function trackingReducer(
    state: any,
    action: Action,
) {
    return trackingsReducer(state, action);
}
